export default {
  pageTitle: 'ラジアントチューブ製作',
  metaDescription: 'TEFは高ニッケル合金を用いて、プロセス産業の炉・加熱用途向けU字型ラジアントチューブおよびヒーターチューブを製作しています。',
  sidebar: {
    title: '製作品一覧',
    vessel: 'ベッセル製作',
    heatExchanger: '熱交換器製作',
    piping: '配管製作',
    tower: 'タワー製作',
    muffle: 'マッフル製作',
    radiantTube: 'ラジアントチューブ製作',
    otherEquipment: 'その他設備製作',
  },
  fabricationOf: '製作',
  productName: 'ラジアントチューブ',
  description: '以下は、当社のラジアントチューブ製作における、様々な材質・種類・仕様に関する実績カタログです。',
};
